// removed by extract-text-webpack-plugin
module.exports = {"body":"winnerDialog__body___RDgWJ","overlay":"winnerDialog__overlay___3Qcr3"};


//////////////////
// WEBPACK FOOTER
// ./containers/WinnerDialog/winnerDialog.css
// module id = 280
// module chunks = 0